// extracted by mini-css-extract-plugin
export default {"main":"Home_main__0Zk-Z","input":"Home_input__UROsx","welcome":"Home_welcome__xVixV"};